/**
 * Free Shipping Progress Bar Enhancement
 * Adds interactive features and animations to the progress bar
 */
class FreeShippingProgress {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
    this.animateProgressBar();
  }

  bindEvents() {
    // Listen for cart updates
    document.addEventListener('cart:updated', () => {
      this.updateProgressBar();
    });

    // Listen for cart item changes
    document.addEventListener('cart:item:changed', () => {
      this.updateProgressBar();
    });
  }

  animateProgressBar() {
    const progressBars = document.querySelectorAll('.free-shipping-progress__bar-fill');
    
    progressBars.forEach(bar => {
      const progress = bar.dataset.progress;
      if (progress && progress > 0) {
        // Add entrance animation
        bar.style.width = '0%';
        setTimeout(() => {
          bar.style.width = progress + '%';
        }, 100);
      }
    });
  }

  updateProgressBar() {
    // This will be called when cart updates
    // The progress bar will automatically update via Liquid
    setTimeout(() => {
      this.animateProgressBar();
    }, 300);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FreeShippingProgress();
  });
} else {
  new FreeShippingProgress();
}

// Export for potential use in other modules
window.FreeShippingProgress = FreeShippingProgress;
